import { useCallback } from "react";

import type { VoucherIssuedMarkVoucherAsUnUsedInput } from "@/lib/gql/__generated__/graphql";

import { useCustomMutation } from "@/hooks/use-graphql-client";

import { VoucherIssuedMarkVoucherAsUnUsed_ECReceiptDetailPage_Mutation } from "./mutation";
import { EcReceiptDetail_ManagementECPage_Query } from "../../query/fetch-ec-receipt-detail/query";

export const useMarkVoucherAsUnUsed = () => {
	const { mutationFunc } = useCustomMutation(
		VoucherIssuedMarkVoucherAsUnUsed_ECReceiptDetailPage_Mutation, //
	);

	const markVoucherAsUnUsed = useCallback(
		async ({ hotelID, voucherCode, receiptID }: VoucherIssuedMarkVoucherAsUnUsedInput & { receiptID: string }) => {
			return await mutationFunc({
				variables: {
					input: {
						hotelID,
						voucherCode,
					},
				},
				refetchQueries: [
					{
						query: EcReceiptDetail_ManagementECPage_Query,
						variables: {
							hotelID,
							receiptID,
						},
					},
				],
			});
		},
		[mutationFunc],
	);

	return {
		markVoucherAsUnUsed,
	};
};
